import React from "react";
import { Link } from "react-router-dom";

export default function ProductCard({ product, compact = false }) {
  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block"
    >
      <div className={`image-soft mb-3 md:mb-4 relative overflow-hidden ${compact ? "aspect-[4/5]" : "aspect-[3/4]"}`} style={{ background: "var(--kaiya-bg-2)" }}>
        <img
          src={product.images?.[0]}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
          loading="lazy"
        />
      </div>
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-1 sm:gap-4">
        <div className="min-w-0 flex-1">
          <div className="label-eyebrow mb-0.5 md:mb-1">Monotype by @kelseyltc</div>
          <h3 className={`font-serif-display leading-tight ${compact ? "text-xl md:text-2xl" : "text-2xl"}`}>&apos;{product.name}&apos;</h3>
        </div>
        <div className={`font-serif-display shrink-0 ${compact ? "text-lg md:text-lg" : "text-lg"}`}>${product.price.toFixed(2)}</div>
      </div>
    </Link>
  );
}
